import countries from "../data/countries.json";

export function getCountries() {
  return countries;
}
